import './styles.css';

const ImageFallback = ({
  text = 'Image indisponible',
  className,
}: {
  text?: string;
  className?: string;
}) => {
  return (
    <div className={`image-fallback ${className ?? ''}`.trim()}>
      <span className="image-fallback-text">{text}</span>
    </div>
  )
}

export default ImageFallback;